import { set } from 'lodash';
import QueryString from 'query-string';

export function stringify(value, { autoBracketArrays = true, nested = false, _keyPrefix = '', ...options } = {}) {
  if (nested && value instanceof Object && !(value instanceof Array)) {
    const params = [];

    for (const key in value) {
      let keySuffix;
      let arrayBrackets = '';
      if (key.endsWith('[]')) {
        arrayBrackets = '[]';
        keySuffix = key.replace(arrayBrackets, '');
      } else {
        keySuffix = key;
      }

      let keyPrefix;
      if (_keyPrefix) {
        keyPrefix = `${_keyPrefix}[${keySuffix}]${arrayBrackets}`;
      } else {
        keyPrefix = `${keySuffix}${arrayBrackets}`;
      }

      params.push(stringify(value[key], { autoBracketArrays, nested, _keyPrefix: keyPrefix, ...options }));
    }

    return params.join('&');
  } else if (_keyPrefix) {
    if (autoBracketArrays && value instanceof Array) {
      const keyPrefix = _keyPrefix ? `${_keyPrefix}[]` : _keyPrefix;
      return value
        .map(element => stringify(element, { autoBracketArrays, nested, _keyPrefix: keyPrefix, ...options }))
        .join('&');
    } else {
      return QueryString.stringify({ [_keyPrefix]: value }, options);
    }
  } else {
    return QueryString.stringify(value, options);
  }
}

// Reconstruct a nested params object from a flattened manual params objects
// { 'q[some_field]: 'somevalue' } => { q: { some_field: 'some_value } }
export function postify(flatParams) {
  const nestedParams = {};
  for (const key of Object.keys(flatParams)) {
    set(nestedParams, key, flatParams[key]);
  }
  return nestedParams;
}
